// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationScenarioBank,
  SimulationScenarioBankT,
  verifySimulationScenarioBank,
} from "./simulation-scenario-bank";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A saved simulation scenario.
 */
export class SimulationScenario implements flatbuffers.IUnpackableObject<SimulationScenarioT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationScenario {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationScenario(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationScenario,
  ): SimulationScenario {
    return (obj || new SimulationScenario()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationScenario(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationScenario,
  ): SimulationScenario {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationScenario()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Slug of the sandbox the run connects through.
   */
  sandbox(): string | null;
  sandbox(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  sandbox(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  banks(index: number, obj?: SimulationScenarioBank): SimulationScenarioBank | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new SimulationScenarioBank()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  banksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * RFC 3339.
   */
  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedBy(): string | null;
  updatedBy(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedBy(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSimulationScenario(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, organizationIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, descriptionOffset, 0);
  }

  static addSandbox(builder: flatbuffers.Builder, sandboxOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, sandboxOffset, 0);
  }

  static addBanks(builder: flatbuffers.Builder, banksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, banksOffset, 0);
  }

  static createBanksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBanksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, updatedAtOffset, 0);
  }

  static addUpdatedBy(builder: flatbuffers.Builder, updatedByOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedByOffset, 0);
  }

  static endSimulationScenario(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // organization_id
    builder.requiredField(offset, 8); // name
    return offset;
  }

  unpack(): SimulationScenarioT {
    return new SimulationScenarioT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.name(),
      this.description(),
      this.sandbox(),
      this.bb!.createObjList<SimulationScenarioBank, SimulationScenarioBankT>(
        this.banks.bind(this),
        this.banksLength(),
      ),
      this.createdAt(),
      this.updatedAt(),
      this.updatedBy(),
    );
  }

  unpackTo(_o: SimulationScenarioT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.name = this.name();
    _o.description = this.description();
    _o.sandbox = this.sandbox();
    _o.banks = this.bb!.createObjList<SimulationScenarioBank, SimulationScenarioBankT>(
      this.banks.bind(this),
      this.banksLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.updatedBy = this.updatedBy();
  }

  unpackFields(...fields: string[]): SimulationScenarioT {
    const t = new SimulationScenarioT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("sandbox")) {
      t.sandbox = this.sandbox();
    }
    if (fieldSet.has("banks")) {
      t.banks = this.bb!.createObjList<SimulationScenarioBank, SimulationScenarioBankT>(
        this.banks.bind(this),
        this.banksLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("updated_by")) {
      t.updatedBy = this.updatedBy();
    }
    return t;
  }
}

export class SimulationScenarioT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public description: string | Uint8Array | null = null,
    public sandbox: string | Uint8Array | null = null,
    public banks: SimulationScenarioBankT[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public updatedBy: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const description = this.description !== null ? builder.createString(this.description!) : 0;
    const sandbox = this.sandbox !== null ? builder.createString(this.sandbox!) : 0;
    const banks = SimulationScenario.createBanksVector(
      builder,
      builder.createObjectOffsetList(this.banks),
    );
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const updatedBy = this.updatedBy !== null ? builder.createString(this.updatedBy!) : 0;

    SimulationScenario.startSimulationScenario(builder);
    SimulationScenario.addId(builder, id);
    SimulationScenario.addOrganizationId(builder, organizationId);
    SimulationScenario.addName(builder, name);
    SimulationScenario.addDescription(builder, description);
    SimulationScenario.addSandbox(builder, sandbox);
    SimulationScenario.addBanks(builder, banks);
    SimulationScenario.addCreatedAt(builder, createdAt);
    SimulationScenario.addUpdatedAt(builder, updatedAt);
    SimulationScenario.addUpdatedBy(builder, updatedBy);

    return SimulationScenario.endSimulationScenario(builder);
  }

  clone(): SimulationScenarioT {
    const obj = new SimulationScenarioT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.name = this.name;
    obj.description = this.description;
    obj.sandbox = this.sandbox;
    obj.banks = this.banks.map((e) => e.clone());
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.updatedBy = this.updatedBy;
    return obj;
  }

  equals(other: SimulationScenarioT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.name !== other.name) return false;
    if (this.description !== other.description) return false;
    if (this.sandbox !== other.sandbox) return false;
    if (this.banks.length !== other.banks.length) return false;
    for (let i = 0; i < this.banks.length; i++) {
      const a = this.banks[i];
      const b = other.banks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.updatedBy !== other.updatedBy) return false;
    return true;
  }
}

export function verifySimulationScenario(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "organization_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationScenarioBank);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
